import React from "react";
import "../styles/loading.css";
const Loading = () => {
  return (
    <>
      <div className="loading-cnt"></div>
      <div className="loading-parent">
        <span className="loader">
          {" "}
          <span style={{ color: "transparent" }}>eee</span>{" "}
        </span>
      </div>
    </>
  );
};

export default Loading;
